export const getBreakdownPerTaskVerticalPage = groupData => {
  var _groupData$analysisDa;
  const rulesStatusMap = (_groupData$analysisDa = groupData.analysisData) == null || (_groupData$analysisDa = _groupData$analysisDa.summary) == null ? void 0 : _groupData$analysisDa.rulesStatusMap;
  if (!rulesStatusMap) {
    return [];
  }
  return Object.entries(rulesStatusMap).map(_ref => {
    let [ruleName, status] = _ref;
    return {
      is_cross: groupData.isTpaPage,
      page_count: groupData.scannedPages,
      page_id: groupData.pageId,
      page_type: groupData.itemType,
      task_name: ruleName,
      task_status: status
    };
  });
};
//# sourceMappingURL=get-breakdown-per-task-vertical-page.js.map